import { render, staticRenderFns } from "./timeline.vue?vue&type=template&id=c895682e&scoped=true"
import script from "./timeline.vue?vue&type=script&lang=js"
export * from "./timeline.vue?vue&type=script&lang=js"
import style0 from "./timeline.vue?vue&type=style&index=0&id=c895682e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c895682e",
  null
  
)

export default component.exports